import { fetcher } from "helpers/fetcher";

import { TUpdateEmployeeSettingReq, TUpdateEmployeeSettingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const updateEmployeeSetting = async (
  payload: TUpdateEmployeeSettingReq
) => {
  return await fetcher<
    TUpdateEmployeeSettingRes,
    TUpdateEmployeeSettingReq["data"]
  >(ENDPOINT.USER.UPDATE_EMPLOYEE_SETTING, {
    data: payload.data,
    headers: {
      [API_HEADER.VERSION]: ENDPOINT.USER.UPDATE_EMPLOYEE_SETTING.version,
      [API_HEADER.USER_ID]: payload.idUser,
    },
  });
};

export const mutationUpdateEmployeeSetting = async (
  payload: TUpdateEmployeeSettingReq
) => {
  return (await updateEmployeeSetting(payload)).data;
};

mutationUpdateEmployeeSetting._key = (payload: TUpdateEmployeeSettingReq) => [
  ENDPOINT.USER.UPDATE_EMPLOYEE_SETTING.url,
  payload,
];
